import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Goals Redux States
import {
  GET_GOALS,
  GET_GOAL,
  CREATE_GOAL,
  EDIT_GOAL,
  DELETE_GOAL,
} from "./actionTypes";
import {
  setGoals,
  apiError,
  setGoal,
  createGoalSuccess,
  editGoalSuccess,
  deleteGoalSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getGoals({ payload: { page, qnt, name} }) {
  try {
    const response = yield call(
      axios.get,
      `/goal?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setGoals(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createGoal({ payload: { newGoalValues } }) {
  try {
    const response = yield call(
      axios.post,
      `/goal`,
      newGoalValues
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createGoalSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getGoal({ payload: { idGoal, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/goal?${
        (idGoal ? `id=${idGoal}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setGoal(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editGoal({
  payload: { idGoal, newGoalValues },
}) {
  try {
    const response = yield call(
      axios.patch,
      `/goal?${
        idGoal ? `id=${idGoal}` : ""
      }`,
      newGoalValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editGoalSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteGoal({ payload: { idGoal } }) {
  try {
    const response = yield call(
      axios.delete,
      `/goal${
        idGoal ? `?id=${idGoal}` : ""
      }`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteGoalSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchGoal() {
  yield takeEvery(GET_GOALS, getGoals);
}
export function* watchGetGoal() {
  yield takeEvery(GET_GOAL, getGoal);
}
export function* watchCreateGoal() {
  yield takeEvery(CREATE_GOAL, createGoal);
}
export function* watchEditGoal() {
  yield takeEvery(EDIT_GOAL, editGoal);
}
export function* watchDeleteGoal() {
  yield takeEvery(DELETE_GOAL, deleteGoal);
}
function* authSaga() {
  yield all([
    fork(watchGoal),
    fork(watchGetGoal),
    fork(watchCreateGoal),
    fork(watchEditGoal),
    fork(watchDeleteGoal),
  ]);
}

export default authSaga;
